module.exports = __webpack_public_path__ + "static/media/Cert III Business.88269633.pdf";